import {Component, Input, OnInit} from '@angular/core';
import {PaginationInstance} from 'ngx-pagination';

declare var resetActions: Function;

@Component({ standalone: false, 
  selector: 'app-pagination-custom',
  templateUrl: './pagination-custom.component.html',
})
export class PaginationCustomComponent implements OnInit {

  @Input() config: PaginationInstance;
  constructor() { }

  ngOnInit() {
  }
  filterPage(pageInput, pages) {
    if (!isNaN(Number(pageInput)) && Number.isInteger(Number(pageInput)) && pageInput > 0 && pageInput <= pages.length) {
      this.config.currentPage = pageInput;
      return this.config.currentPage;
    } else {
      return this.config.currentPage;
    }
  }

  resetActions(id) {
    setTimeout(() => {
      resetActions(id);
    }, 500);
  }
}
